import { IconButton } from '@mui/material';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import dayjs from 'dayjs';

const CustomCalendarHeader = (props) => {
  const { currentMonth, onMonthChange } = props;

  const handlePrevMonth = () => {
    onMonthChange(dayjs(currentMonth).subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    onMonthChange(dayjs(currentMonth).add(1, 'month'));
  };

  const navButtonStyles = {
    outline: 'none',
    boxShadow: 'none',
    borderRadius: '6px',
    border: '2px solid #E4E4E7',
    color:"black",
    opacity: 0.5,
    padding: '4px',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  };

  return (
    <div className="flex items-center justify-between px-4 py-2">
      <IconButton sx={navButtonStyles} size="small" onClick={handlePrevMonth}>
        <ArrowBackIosNew fontSize="inherit" />
      </IconButton>

      <span className="text-sm font-medium capitalize">
        {dayjs(currentMonth).format('MMMM YYYY')}
      </span>

      <IconButton sx={navButtonStyles} size="small" onClick={handleNextMonth}>
        <ArrowForwardIos fontSize="inherit" />
      </IconButton>
    </div>
  );
};

export default CustomCalendarHeader;
